<template>
  <UnauthorizedBlock>

    <form @submit.prevent="" class="grid grid-cols-1 row-gap-8">
      <div class="text-xl font-bold text-text leading-tight">
        {{ $t('title') }}
      </div>
      <PasswordInput v-model.trim="$v.password.$model"
                     :label="$t('passwordLabel')"
                     :password-reveal="true"
                     :error="$v.password.$error || !!serverError.password_reset_token">

        <template v-slot:errors="">
          <div class="error" v-if="!$v.password.required">{{ $t('errors.required') }}</div>
          <div class="error" v-if="!$v.password.minLength">{{ $t('errors.passwordMinLength') }}</div>
          <div class="error" v-if="!!serverError.password_reset_token">{{ serverError.password_reset_token }}
          </div>
        </template>
      </PasswordInput>
      <PasswordInput v-model.trim="$v.password_confirmation.$model"
                     type="password"
                     :label="$t('repeatPasswordLabel')"
                     :password-reveal="true"
                     :error="$v.password_confirmation.$error">
        <template v-slot:errors="">
          <div class="error" v-if="!$v.password_confirmation.required">{{ $t('errors.required') }}</div>
          <div class="error" v-if="!$v.password_confirmation.sameAsPassword">{{ $t('errors.required') }}</div>
        </template>
      </PasswordInput>
      <BaseButton @click="restorePassword"
                 theme="red" class="w-full"
                 :loading="$v.$invalid">
        {{ $t('setupNewPassword') }}
      </BaseButton>
    </form>
  </UnauthorizedBlock>
</template>

<script>
import {mapActions} from "vuex";
import {required, sameAs, minLength} from 'vuelidate/lib/validators'
import UnauthorizedBlock from "@/components/layouts/common/UnauthorizedBlock";
import PasswordInput from "@/components/UI/BaseInput/PasswordInput";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "Password",
  components: {
    BaseButton,
    PasswordInput,
    UnauthorizedBlock
  },
  data() {
    return {
      serverError: {
        password_reset_token: ''
      },
      password: '',
      password_confirmation: '',
      submitted: false
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
    password_confirmation: {
      required,
      sameAsPassword: sameAs('password')
    },
  },
  methods: {
    ...mapActions('auth', ['reset_password']),
    showErrors(message) {
      this.serverError.password_reset_token = message.password_reset_token
    },
    clearErrors() {
      this.serverError.password_reset_token = '';
    },
    restorePassword() {
      let data = {
        password: this.password,
        token: this.$route.params.token
      };
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.reset_password(data).then((res) => {
          if (res.body.success) {
            this.password = '';
            this.password_confirmation = '';
            this.$router.push('/login');
          } else {
            this.showErrors(res.body.message);
            this.submitted = false;
            setTimeout(() => {
              this.clearErrors();
            }, 5000)
          }
        })
      } else {
        this.submitted = false;
      }
    }
  },
  mounted() {
    if (!this.$route.params.token) {
      this.$router.push('/login');
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Password Recovery',
        passwordLabel: 'Enter new password',
        repeatPasswordLabel: 'Repeat new password',
        setupNewPassword: 'Set new password'
      },
      ru: {
        title: 'Восстановление пароля',
        passwordLabel: 'Введите новый пароль',
        repeatPasswordLabel: 'Повторите новый пароль',
        setupNewPassword: 'Установить новый пароль'
      }
    }
  }
}
</script>